import css from "styled-jsx/css";
import Colors from "styles/colors";

export const errorCareersCommonStyles = css`
  .error-careers-component {
    display: flex;
    flex-direction: column;
    align-items: center;

    .error-message {
      margin: 90px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      width: 494px;

      .cactus {
        width: 180px;
        height: 220px;
      }

      .title {
        margin-top: 8px;
        font-style: normal;
        font-weight: bold;
        font-size: 1.75rem;
        line-height: 32px;
        text-align: center;
        color: ${Colors["mud"]};
      }

      .content {
        margin-top: 24px;
        font-style: normal;
        font-weight: normal;
        font-size: 1rem;
        line-height: 28px;
        text-align: center;
        color: ${Colors["tuna"]};
        a,
        a:hover,
        a:visited {
          color: ${Colors["brand-blue"]};
        }
      }
    }
  }
`;
